import React from "react";
import loginToken from "../authComponents/localStorageItems/LoginTokin";
import baseURL from "../authComponents/baseURL/BaseURL";
import { authSliceActions } from "../../redux/slices/authSlice";
// import { useNavigate } from "react-router-dom";
import {
  FaHeart,
  FaBirthdayCake,
  FaMapMarkerAlt,
  FaPrayingHands,
  FaUser,
  FaUserGraduate,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Helper function to format strings from snake_case to Title Case
const getProperString = (string) => {
  if (!!string) {
    return string
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    return "--";
  }
};

const ProfileCard = ({ profile }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleViewProfle = async () => {
    if (!loginToken) {
      navigate("/login");
    }

    try {
      const response = await baseURL.get(`/profile`, {
        headers: {
          Authorization: `Bearer ${loginToken}`,
        },
      });
      dispatch(authSliceActions.getStatus(response.data.data.status));
    } catch (error) {
      if (error.status === 401) {
        localStorage.removeItem("authToken");
        window.location.reload();
      }
      // console.error(
      //   "Error fetching profile:",
      //   error.response?.data || error.message
      // );
    }
  };

  return (
    <div className="overflow-hidden border border-[#730000] rounded-lg shadow-lg shadow-[#730000] p-4 min-w-[30%]">
      {/* Profile Header */}
      <div className="flex items-start space-x-4 max-lg:space-x-0">
        <img
          src={
            profile.main_image ||
            profile.gender === "female"
              ? "https://static.vecteezy.com/system/resources/previews/029/271/069/non_2x/avatar-profile-icon-in-flat-style-female-user-profile-illustration-on-isolated-background-women-profile-sign-business-concept-vector.jpg"
              : profile.gender === "male"
              ? "https://static.vecteezy.com/system/resources/previews/029/271/062/non_2x/avatar-profile-icon-in-flat-style-male-user-profile-illustration-on-isolated-background-man-profile-sign-business-concept-vector.jpg"
              : profile.main_image ||
                "https://static.vecteezy.com/system/resources/previews/029/271/062/non_2x/avatar-profile-icon-in-flat-style-male-user-profile-illustration-on-isolated-background-man-profile-sign-business-concept-vector.jpg"
          }
          alt="profile"
          className="w-32 h-32 rounded-full max-lg:h-20 max-lg:w-20 max-lg:ml-[-1rem]"
        />
        <div className="text-left">
          <p className="text-[#730000] font-semibold">
            {profile.first_name} {profile.last_name}
          </p>
          <p className="text-gray-600 w-52 max-sm:w-full line-clamp-3 max-lg:text-[0.9rem] overflow-hidden">
            {profile.title}
          </p>
          <Link
            to={`/profile-details/${profile.id}`}
            onClick={handleViewProfle}
          >
            <button className="bg-[#730000] text-white px-2 py-1 rounded mt-4 w-[60%] max-sm:w-20">
              Full Profile &gt;&gt;
            </button>
          </Link>
        </div>
      </div>

      {/* Profile Details */}
      <div className="grid grid-cols-2 w-full mt-4 gap-4 text-gray-700 self-end">
        {/* Marital Status and Age */}
        <div className="flex items-center space-x-2">
          <FaHeart className="text-pink-500" />
          <p>{getProperString(profile.marital_status)}</p>
        </div>
        <div className="flex items-center space-x-2">
          <FaBirthdayCake className="text-pink-500" />
          <p>{profile.age || "N/A"}</p>
        </div>

        {/* Location */}
        <div className="flex items-center space-x-2">
          <FaMapMarkerAlt className="text-pink-500" />
          <p>{profile.city || "City N/A"}</p>
        </div>
        <div className="flex items-center space-x-2">
          <FaMapMarkerAlt className="text-pink-500" />
          <p>{profile.country || "Country N/A"}</p>
        </div>

        {/* Religion and Gender */}
        <div className="flex items-center space-x-2">
          <FaPrayingHands className="text-pink-500" />
          <p>{getProperString(profile.religion)}</p>
        </div>
        {/* <div className="flex items-center space-x-2">
          <FaUser className="text-pink-500" />
          <p>{getProperString(profile.gender)}</p>
        </div> 

        {/* Profession */}
        <div className="flex items-center space-x-2">
          <FaUserGraduate className="text-pink-500" />
          <p>{getProperString(profile.occupation)}</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
